import React from 'react';
import { OrderedList } from '../../../../../common/display/orderedList/OrderedList';
import { ImageSource } from '../../../../../common/display/imageSource/ImageSource';
import PaperAndPenPng from '../images/paper-and-pen.png';
import PaperAndPenWebp from '../images/paper-and-pen.webp';
import Section2Png from '../images/section2.png';
import Section2Webp from '../images/section2.webp';
import Section3Png from '../images/section3.png';
import Section3Webp from '../images/section3.webp';
import { useIntl } from '@/i18n';

const HowItWorksTab = () => {
  const { t } = useIntl();
  const Item = OrderedList.Item;

  return (
    <div className='margin-bottom-xxl'>
      <OrderedList>
        <Item
          image={
            <ImageSource
              image={PaperAndPenPng}
              imageWebp={PaperAndPenWebp}
              imageAlt={t({
                id: 'benefits.deposit.modal.howItWorks.image1',
                defaultMessage: 'paper and pen',
              })}
              sizes='100px'
            />
          }
          text={t({
            id: 'benefits.deposit.modal.howItWorks.description1',
            defaultMessage: 'Enter your details',
          })}
        />
        <Item
          image={
            <ImageSource
              image={Section2Png}
              imageWebp={Section2Webp}
              imageAlt={t({
                id: 'benefits.deposit.modal.howItWorks.image2',
                defaultMessage: 'opened phone',
              })}
              sizes='100px'
            />
          }
          text={t({
            id: 'benefits.deposit.modal.howItWorks.description2',
            defaultMessage: 'get your documents',
          })}
        />
        <Item
          image={
            <ImageSource
              image={Section3Png}
              imageWebp={Section3Webp}
              imageAlt={t({
                id: 'benefits.deposit.modal.howItWorks.image3',
                defaultMessage: 'download',
              })}
              sizes='100px'
            />
          }
          text={t({
            id: 'benefits.deposit.modal.howItWorks.description3',
            defaultMessage: 'or directly download',
          })}
        />
      </OrderedList>
    </div>
  );
};

export default HowItWorksTab;
